// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependancies=================
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

// ==================react hook=================
import { useDispatch } from 'react-redux';

// ==================Actions=================
import { setOpenPopper, setSaveNetworkClicked } from '../../../actions/site';

export default function buttonNetwork(props) {
  const dispatch = useDispatch();
  const { valueFormatted, value, data } = props;
  const cellValue = valueFormatted || value;
  const transformNetwork = cellValue.split(' & ');
  // function to display action when button clicked, here save value of marker in state
  const buttonClicked = () => {
    dispatch(setOpenPopper(true));
    dispatch(setSaveNetworkClicked(transformNetwork, data.marker));
  };
  return <Button onClick={() => buttonClicked()}>{cellValue}</Button>;
}

buttonNetwork.propTypes = {
  props: PropTypes.objectOf(),
};
